module.exports = {"pathContext":{"slug":"/en/multires/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en-multires.json
// module id = 1555
// module chunks = 235554121860001